import { Tooltip } from '@civilgrid/ui/components';
import type { MapObject } from '~/common/types';
import Icon from '~/components2/Icon';
import { imageFullscreenState } from './ImageFullscreen';

interface ImagePreviewProps {
  currentObject: MapObject;
}

export default function ({ currentObject }: ImagePreviewProps) {
  if (currentObject.type !== 'image') {
    return null;
  }

  const { files } = currentObject;

  if (!files || files.length === 0) {
    return <div className="italic">Loading...</div>;
  }

  const { path } = files[0];
  const { id, title } = currentObject;

  return (
    <div className="mb-6 h-full w-full space-y-4">
      <div className="text-base font-bold">Preview</div>
      <div id="preview-image-container" className="group relative">
        <Tooltip asChild text="View Fullscreen" side="top" align="end" sideOffset={5}>
          <button
            type="button"
            aria-label="View fullscreen"
            data-testid="civildraw-image-preview-fullscreen"
            onClick={() => {
              imageFullscreenState.setImage(id, title || 'Image', files[0]);
            }}
            className="pointer-events-none absolute right-2 top-2 flex cursor-pointer appearance-none items-center justify-center rounded border-0 bg-white p-0.5 opacity-0 outline-hidden hover:bg-grey-20 focus-visible:pointer-events-auto focus-visible:opacity-100 focus-ring group-hover:pointer-events-auto group-hover:opacity-100"
          >
            <Icon icon="maximize" size={16} />
          </button>
        </Tooltip>
        <img src={path} alt={title || 'Preview'} className="max-h-full max-w-full" />
      </div>
    </div>
  );
}
